/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Dispute_TitleInputs */

const en_impressum_dispute_title = /** @type {(inputs: Impressum_Dispute_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispute Resolution`)
};

const de_impressum_dispute_title = /** @type {(inputs: Impressum_Dispute_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streitbeilegung`)
};

const fr_impressum_dispute_title = /** @type {(inputs: Impressum_Dispute_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Règlement des litiges de l'UE`)
};

const es_impressum_dispute_title = /** @type {(inputs: Impressum_Dispute_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolución de disputas de la UE`)
};

const it_impressum_dispute_title = /** @type {(inputs: Impressum_Dispute_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risoluzione delle controversie UE`)
};

const nl_impressum_dispute_title = /** @type {(inputs: Impressum_Dispute_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-geschillenbeslechting`)
};

const pl_impressum_dispute_title = /** @type {(inputs: Impressum_Dispute_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozstrzyganie sporów w UE`)
};

const fi_impressum_dispute_title = /** @type {(inputs: Impressum_Dispute_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU:n riitojenratkaisu`)
};

const da_impressum_dispute_title = /** @type {(inputs: Impressum_Dispute_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU-tvistbilæggelse`)
};

const sv_impressum_dispute_title = /** @type {(inputs: Impressum_Dispute_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`EU:s tvistlösning`)
};

/**
* | output |
* | --- |
* | "Dispute Resolution" |
*
* @param {Impressum_Dispute_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_dispute_title = /** @type {((inputs?: Impressum_Dispute_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Dispute_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_dispute_title(inputs)
	if (locale === "fr") return fr_impressum_dispute_title(inputs)
	if (locale === "es") return es_impressum_dispute_title(inputs)
	if (locale === "it") return it_impressum_dispute_title(inputs)
	if (locale === "nl") return nl_impressum_dispute_title(inputs)
	if (locale === "pl") return pl_impressum_dispute_title(inputs)
	if (locale === "fi") return fi_impressum_dispute_title(inputs)
	if (locale === "da") return da_impressum_dispute_title(inputs)
	if (locale === "sv") return sv_impressum_dispute_title(inputs)
	return en_impressum_dispute_title(inputs)
});